import { render, staticRenderFns } from "./RecoveredProjects.vue?vue&type=template&id=693752aa&scoped=true&"
import script from "./RecoveredProjects.vue?vue&type=script&lang=js&"
export * from "./RecoveredProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693752aa",
  null
  
)

export default component.exports